import React from "react";
import { Box, Stack } from "@mui/material";
import ActionButton from "../../components/commonComponents/Buttons/ActionButton";
import { Add } from "@mui/icons-material";
import { StyledMainBox } from "../../components/commonComponents/StyledComponents/styled";
import AddNewClip from "./ModalContent/AddClip";
import mediaClip from "../../images/campaign/clip/REWE_Azhari_ZitronenimWasser.mp4";
import AccessControl from "../../components/commonComponents/Hoc/AccessControl";

import ClipsListing from "./listings/ClipsListing";
import { resetClipsData } from "../../api_calls/clipRequests";
import ClipListFilters from "./filters/ClipListFilters";
import { resetBrandReportView } from "../../api_calls/utils";
import { checkUserPermissions } from "../../api_calls/userManagement";
import { useDispatch, useSelector } from "react-redux";
import { resetListingCheckData } from "../../api_calls/listingCheck";
import { deleteItems } from "../../Store/actions";

const Clips = () => {
  const Clips = useSelector((state) => state.userSelections);
  const [isModalOpen, setIsModalOpen] = React.useState(false);
  const allowedAccessRights = checkUserPermissions();
  const permissionScope = allowedAccessRights.allowed_access;
  const dispatchAction = useDispatch();

  const closeModal = () => {
    resetClipsData();
    resetListingCheckData();
    setIsModalOpen(false);
  };

  const openModal = () => {
    setIsModalOpen(true);
  };

  React.useEffect(() => {
    resetBrandReportView();
    // Resetting detailed store filters 
    return () => {
      dispatchAction(deleteItems(["store_list_filter_applied", "detailed_stores_filtered"]));
    };
  }, []);

  return (
    <>
      <StyledMainBox component="main">
        {/* <Box height={30} /> */}
        <h1>Contact-based Visuals</h1>
        {/* ============ chose data fields button =========== */}
        {permissionScope.clip_list_can_edit === true && (
          <Stack direction="row" spacing={2}>
            <ActionButton
              onClick={(e) => {
                e.preventDefault();
                openModal();
              }}
              label={"New Visual"}
              icon={<Add />}
            />
          </Stack>
        )}

        {/* --------------- filters ------------- */}
        <Box height={30} />
        {
          typeof Clips.clips_list !== "undefined" && <ClipListFilters />
        }

        {/* ============== campaign listing ============ */}
        <Box height={30} />
        <ClipsListing />
      </StyledMainBox>
      {/* ============ modal popup to add clips ========== */}
      {isModalOpen && (
        <AddNewClip open={isModalOpen} onClose={closeModal} size={"md"} closeModal={closeModal} usedFor={"add"} />
      )}
    </>
  );
};

export default AccessControl(Clips, ["clip_list_can_view", "clip_list_can_edit"], [], ["campaigns_section", "clips"]);
